export class TagKeyValue {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TagKeyValue.attributeTypeMap;
    }
    constructor() {
    }
}
